<template>
  <div class="text-center mx-16 mt-8">
    <v-row>
      <v-col cols="6">
        <v-select @change="getData()" color="black" label="نوع فایل را مشخص کنید " v-model="fileType" :items="items"
                  item-text="text" item-value="value"></v-select>
      </v-col>
      <v-col cols="6">
        <v-text-field label="نام فولدر" v-model="folderName" color="black"></v-text-field>
      </v-col>
    </v-row>
    <!--    LESSON FILE-->
    <v-row v-if="folderName && fileType === 'lesson_file'">
      <v-col cols="12">
        <drag-and-drop :module="'lesson_file'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
      <v-col cols="3">
        <v-text-field color="black" v-model="itemFile.title" label="عنوان"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-select label="دسته بندی" :items="itemFileCategories" item-text="label" item-value="id"
                  color="black" v-model="itemFile.category_id">
        </v-select>
      </v-col>
      <v-col cols="2">
        <v-select label="وضعیت نمایش"
                  :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                  color="black" v-model="itemFile.visibility">
        </v-select>
      </v-col>
      <v-col cols="1">
        <v-select label="نوع فایل" :items="fileTypes"
                  color="black" v-model="itemFile.mime_type">
        </v-select>
      </v-col>
      <v-col cols="3">
        <v-autocomplete :items="itemFileCovers" item-text="tag" item-value="id" v-model="itemFile.cover_id"
                        label="کاور مورد نظر را انتخاب کنید"></v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-textarea color="black" v-model="itemFile.description" label="توضیحات فایل درسی">
        </v-textarea>
      </v-col>
      <v-col cols="6">
        <v-textarea color="black" v-model="itemFile.comment" label="دست نوشته فایل درسی"
                    hint="این نوشته سمت کاربر نمایش داده نمی شود و فقط برای یادداشت شما می باشد که در جستجو از آن استفاده کنید.">
        </v-textarea>
      </v-col>
    </v-row>
    <!--    LessonCover-->
    <v-row v-if="folderName && fileType === 'lesson_file_cover'">
      <v-col cols="6" md="3" lg="3" sm="6">
        <v-text-field color="black" v-model="cover.tag" label="تگ کاور"></v-text-field>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'covers/lesson_file'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>
    <!--    CourseCover-->
    <v-row v-if="folderName && fileType === 'course_cover'">
      <v-col cols="6" md="3" lg="3" sm="6">
        <v-text-field color="black" v-model="cover.tag" label="تگ کاور"></v-text-field>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'covers/course_cover'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>
    <!--    LessonCover-->
    <v-row v-if="folderName && fileType === 'lesson_cover'">
      <v-col cols="6" md="3" lg="3" sm="6">
        <v-text-field color="black" v-model="cover.tag" label="تگ کاور"></v-text-field>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'covers/lesson_cover'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>
    <!--    ClassCover-->
    <v-row v-if="folderName && fileType === 'class_cover'">
      <v-col cols="6" md="3" lg="3" sm="6">
        <v-text-field color="black" v-model="cover.tag" label="تگ کاور"></v-text-field>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'covers/class_cover'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>
    <!--    CategoryCover-->
    <v-row v-if="folderName && fileType === 'category_cover'">
      <v-col cols="6" md="3" lg="3" sm="6">
        <v-text-field color="black" v-model="cover.tag" label="تگ کاور"></v-text-field>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'covers/category_cover'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>

    <!--    Notification-->
    <v-row v-if="folderName && fileType === 'notification'">
      <v-col cols="6">
        <v-text-field color="black" v-model="notification.tag" label="تگ اعلان"></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-select
            label="نوع فایل اعلان را مشخص کنید"
            :items="attachment_types"
            v-model="notification.attachment_type"
            item-value="value"
            item-text="text"
            color="black"
        >
        </v-select>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'notifications'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>

    <!--    message-->
    <v-row v-if="folderName && fileType === 'message'">
      <v-col cols="6">
        <v-text-field color="black" v-model="message.tag" label="تگ پیام"></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-select
            label="نوع فایل پیام را مشخص کنید"
            :items="attachment_types"
            v-model="message.attachment_type"
            item-value="value"
            item-text="text"
            color="black"
        >
        </v-select>
      </v-col>
      <v-col cols="12">
        <drag-and-drop :module="'messages'" :directory="folderName" v-if="fileType && folderName"
                       ref="image-uploader"
                       @changeFile="(event) => {file = event}">
        </drag-and-drop>
      </v-col>
    </v-row>


    <!--    SendFile-->
    <div class="mt-16">
      <v-btn :disabled="!fileType || !folderName || !file" block class="white--text" x-large color="#696cff"
             @click="uploadFile">
        <span v-if="fileType && folderName">
        ذخیره
        </span>
        <span v-else>
          ابتدا فیلد های بالا را وارد کنید.
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
  name: "UploadFile",
  components: {DragAndDrop},
  data() {
    return {
      file: null,
      folderName: null,
      fileType: null,
      itemFileCategories: [],
      itemFileCovers: [],
      fileTypes: [
        {text: 'ویدیو', value: 'video'},
        {text: 'تصویر', value: 'image'},
        {text: 'پی دی اف', value: 'pdf'},
        {text: 'صوتی', value: 'audio'},
        {text: 'نوشته', value: 'text'},
        {text: 'غیره', value: 'other'}
      ],
      attachment_types: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
        {value: 'zip', text: 'فایل فشرده'},
      ],
      notification: {
        attachment_type: null,
        tag: null
      },
      message: {
        attachment_type: null,
        tag: null
      },
      itemFile: {
        title: null,
        category_id: null,
        visibility: null,
        description: null,
        file: null,
        cover_id: null,
        mime_type: null,
        comment: null,
      },
      cover: {
        tag: null,
        file: null,
        type: null
      },
      items: [
        {text: 'فایل درسی', value: 'lesson_file'},
        {text: 'کاور دوره', value: 'course_cover'},
        {text: 'کاور درس', value: 'lesson_cover'},
        {text: 'کاور کلاس', value: 'class_cover'},
        {text: 'کاور دسته بندی', value: 'category_cover'},
        {text: 'کاور فایل درسی', value: 'lesson_file_cover'},
        {text: 'اعلان', value: 'notification'},
        {text: 'پیام', value: 'message'},
      ],
    }
  },
  mounted() {

  },
  methods: {
    getCategoriesForItemFile() {
      window.axios.get('category/index?per_page=1000&type=item_file').then((res) => {
        this.itemFileCategories = res.data.data.data
      })
    },
    getItemFileCovers() {
      window.axios.get('file-manager/cover/index?type=lesson_file_cover&per_page=10000').then((res) => {
        this.itemFileCovers = res.data.data.data
      })
    },
    getData() {
      if (this.fileType === 'lesson_file') {
        this.getItemFileCovers()
        this.getCategoriesForItemFile()
      }
    },

    uploadFile() {
      if (this.fileType === 'lesson_file_cover') {
        window.axios.post("file-manager/cover/create", {
          tag: this.cover.tag,
          url: this.file,
          type: 'lesson_file_cover',
        }).then(() => {
          this.openSnackbar('کاور با موفقیت بارگزاری شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'course_cover') {
        window.axios.post("file-manager/cover/create", {
          tag: this.cover.tag,
          url: this.file,
          type: 'course_cover',
        }).then(() => {
          this.openSnackbar('کاور با موفقیت بارگزاری شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'lesson_cover') {
        window.axios.post("file-manager/cover/create", {
          tag: this.cover.tag,
          url: this.file,
          type: 'lesson_cover',
        }).then(() => {
          this.openSnackbar('کاور با موفقیت بارگزاری شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'class_cover') {
        window.axios.post("file-manager/cover/create", {
          tag: this.cover.tag,
          url: this.file,
          type: 'class_cover',
        }).then(() => {
          this.openSnackbar('کاور با موفقیت بارگزاری شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'category_cover') {
        window.axios.post("file-manager/cover/create", {
          tag: this.cover.tag,
          url: this.file,
          type: 'category_cover',
        }).then(() => {
          this.openSnackbar('کاور با موفقیت بارگزاری شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'lesson_file') {
        window.axios.post("file-manager/item-file/create", {
          folder_name: this.folderName,
          category_id: this.itemFile.category_id,
          visibility: this.itemFile.visibility,
          title: this.itemFile.title,
          description: this.itemFile.description,
          file: this.file,
          cover_id: this.itemFile.cover_id,
          mime_type: this.itemFile.mime_type,
          comment: this.itemFile.comment
        }).then(() => {
          this.openSnackbar('فایل درسی با موفقیت ذخیره شد.(ممکن است چند دقیقه بعد در قسمت ساخت درس در دسترس باشد.) ', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'notification') {
        window.axios.post("file-manager/notification/create", {
          tag: this.notification.tag,
          attachment_type: this.notification.attachment_type,
          file: this.file,
        }).then(() => {
          this.openSnackbar('فایل اعلان با موفقیت ذخیره شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      } else if (this.fileType === 'message') {
        window.axios.post("file-manager/message/create", {
          tag: this.message.tag,
          attachment_type: this.message.attachment_type,
          file: this.file,
        }).then(() => {
          this.openSnackbar('فایل پیام با موفقیت ذخیره شد.', 'success')
        }).catch((err) => {
          this.openSnackbar(err.response.data.message, '#FB4E4E')
        })
      }
    },
    CopyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
  }
}
</script>

<style scoped>

</style>
